export default {
  'result.success.title': '提交成功'
}
